export default __webpack_public_path__ + "static/media/remove.78c696cf.svg";